import { createRouter, createWebHistory } from "vue-router";
import { PATHS, translate } from "@/i18n";
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Experience from "@/views/Experience.vue";
import Projects from "@/views/Projects.vue";
import Community from "@/views/Community.vue";
import NotFound from "@/views/NotFound.vue";

const PAGES = {
  home: {
    component: Home,
    title: { fr: "Arolle Fona · Développeuse fullstack JavaScript", en: "Arolle Fona · Fullstack JavaScript developer" },
    description: {
      fr: "Arolle Fona, développeuse fullstack JavaScript à Douala, co-fondatrice de Dev Girls. Disponible pour des missions freelance.",
      en: "Arolle Fona, fullstack JavaScript developer in Douala, co-founder of Dev Girls. Available for freelance work.",
    },
  },
  about: {
    component: About,
    title: { fr: "À propos · Arolle Fona", en: "About · Arolle Fona" },
    description: {
      fr: "Qui est Arolle Fona : développeuse fullstack JavaScript, co-fondatrice de Dev Girls, passionnée de lecture et d'écriture.",
      en: "Who is Arolle Fona: fullstack JavaScript developer, co-founder of Dev Girls, passionate about reading and writing.",
    },
  },
  experience: {
    component: Experience,
    title: { fr: "Parcours · Arolle Fona", en: "Experience · Arolle Fona" },
    description: {
      fr: "Le parcours professionnel d'Arolle Fona, développeuse fullstack JavaScript.",
      en: "The professional experience of Arolle Fona, fullstack JavaScript developer.",
    },
  },
  projects: {
    component: Projects,
    title: { fr: "Projets · Arolle Fona", en: "Projects · Arolle Fona" },
    description: {
      fr: "Les projets d'Arolle Fona : Overdracht, BumXpress, SM Pay, Digitrade, Dev Girls et RasenganJS.",
      en: "Arolle Fona's projects: Overdracht, BumXpress, SM Pay, Digitrade, Dev Girls and RasenganJS.",
    },
  },
  community: {
    component: Community,
    title: { fr: "Community & Talks · Arolle Fona", en: "Community & Talks · Arolle Fona" },
    description: {
      fr: "La vie communautaire d'Arolle Fona : Dev Girls, ses talks et les événements auxquels elle participe.",
      en: "Arolle Fona's community life: Dev Girls, her talks and the events she takes part in.",
    },
  },
};

const routes = [];
for (const [key, page] of Object.entries(PAGES)) {
  for (const lang of ["fr", "en"]) {
    routes.push({
      path: PATHS[key][lang],
      name: `${key}-${lang}`,
      component: page.component,
      meta: { key, lang, title: translate(page.title, lang), description: translate(page.description, lang) },
    });
  }
}
// Anciennes adresses du site
routes.push({ path: "/skills", redirect: "/about" });
routes.push({ path: "/:pathMatch(.*)*", component: NotFound, meta: { title: "404 · Arolle Fona" } });

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, saved) {
    if (saved) return saved;
    if (to.hash) return { el: to.hash, top: 16 };
    return { top: 0 };
  },
});

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, name] = selector.match(/\[(\w+)="([^"]+)"\]/);
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

router.afterEach((to) => {
  document.title = to.meta.title || "Arolle Fona";
  document.documentElement.lang = to.meta.lang || "fr";
  if (to.meta.description) {
    setMeta('meta[name="description"]', "content", to.meta.description);
    setMeta('meta[property="og:title"]', "content", to.meta.title);
    setMeta('meta[property="og:description"]', "content", to.meta.description);
  }
});

export default router;
